import { PLATFORMS } from '@domain/platform';
import { IconMobees, MainTheme, IconTraktoT } from '@paretogroup/tess';
import { Routes } from '@domain/router';

const STATIC_PATH = '/static/img';

export const BACKGROUND_IMAGE = `${STATIC_PATH}/integrations-onboarding-modal-background.png`;

export const INTEGRATIONS_ONBOARDING_MODAL_TEXTS = {
    ADD_APP: 'Add App',
    KNOW_MORE: 'Want to know more about the product?',
    VISIT: 'Visit the company',
};

export const PLATFORMS_FULFILLMENT = {
    [PLATFORMS.TRAKTO.value]: {
        title: 'The easiest editor on the Internet',
        subtitle: 'Pareto Ads helps hundreds of thousands of professionals (designers and non-designers) and companies around the world to create their marketing and sales materials in just a few clicks. They are 100% editable templates for users to customize as they prefer and it is also possible to create layouts from scratch.',
        icon: IconTraktoT,
        iconTitle: `${PLATFORMS.TRAKTO.name} App`,
        iconSize: 36,
        video: 'https://youtube.com/embed/AsFuVhyelSA',
        visitLink: 'https://www.trakto.io/',
        route: `${Routes.PARTNERSHIPS}/${PLATFORMS.TRAKTO.value}`,
    },
    [PLATFORMS.MOBEES.value]: {
        title: `${PLATFORMS.MOBEES.name} Out-of-home`,
        subtitle: 'You will be capable to launch and monitor campaigns OOH directly from Pareto Ads, with only 1 click!',
        icon: IconMobees,
        iconTitle: `${PLATFORMS.MOBEES.name} App`,
        iconColor: MainTheme.colors['fun-orange'],
        iconSize: 36,
        video: 'https://youtube.com/embed/Ht-5xii_w_M',
        visitLink: 'https://www.mobees.com.br/',
        route: `${Routes.PARTNERSHIPS}/${PLATFORMS.MOBEES.value}`,
    },
};
